/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OktaResourceConnectionConfirmation,
  OktaResourceConnectionConfirmation$Outbound,
  OktaResourceConnectionConfirmation$outboundSchema,
} from "./oktaresourceconnectionconfirmation.js";

export type ConfirmOktaResourceConnectionsRequestBody = {
  /**
   * Servers to confirm with their configured values.
   */
  connections: Array<OktaResourceConnectionConfirmation>;
};

/** @internal */
export type ConfirmOktaResourceConnectionsRequestBody$Outbound = {
  connections: Array<OktaResourceConnectionConfirmation$Outbound>;
};

/** @internal */
export const ConfirmOktaResourceConnectionsRequestBody$outboundSchema:
  z.ZodMiniType<
    ConfirmOktaResourceConnectionsRequestBody$Outbound,
    ConfirmOktaResourceConnectionsRequestBody
  > = z.object({
    connections: z.array(OktaResourceConnectionConfirmation$outboundSchema),
  });

export function confirmOktaResourceConnectionsRequestBodyToJSON(
  confirmOktaResourceConnectionsRequestBody:
    ConfirmOktaResourceConnectionsRequestBody,
): string {
  return JSON.stringify(
    ConfirmOktaResourceConnectionsRequestBody$outboundSchema.parse(
      confirmOktaResourceConnectionsRequestBody,
    ),
  );
}
